export const hotTags = [
  { name: '城市更新', heat: 982000 },
  { name: '大模型', heat: 964000 },
  { name: '低空经济', heat: 921000 },
  { name: '音乐节', heat: 878000 },
  { name: '折叠屏', heat: 845000 },
  { name: '智能驾驶', heat: 812000 },
  { name: '夜间经济', heat: 769000 },
  { name: '国风音乐', heat: 742000 },
  { name: '算力', heat: 708000 },
  { name: '人形机器人', heat: 686000 },
  { name: '银发经济', heat: 654000 },
  { name: '票房', heat: 631000 },
  { name: '芯片', heat: 608000 },
  { name: '校园体育', heat: 572000 },
  { name: '剧集出海', heat: 548000 },
];